import ScoreStore from "./ScoreStore";

export default () => ({
  ...ScoreStore(),
});
